export const initButtonMore = () => {

	const buttons = document.querySelectorAll( 'a.more' );

	if ( buttons.length )
	{
		buttons.forEach( ( button ) => {

			button.addEventListener( 'click', ( evt ) => {

				evt.preventDefault();
				button.disabled = true;
				
				let nextPage = button.getAttribute( 'data-next-page' );
				let href = location.pathname;
				let newHistoryItem = '';
				const component = button.closest( 'section' );
				const componentId = component.getAttribute( 'id' );
				const cardsList = component.querySelector( 'ul.cards' );

				if ( location.search != '' )
				{
					let searchString = location.search;
					
					const pageMatch = searchString.match(/(?<page>[&]?page=(\d+))/);
					if ( pageMatch && pageMatch.groups && pageMatch.groups.page )
					{
						searchString = searchString.replace( pageMatch.groups.page, '' );
					}
					
					const ajaxMatch = searchString.match(/(?<ajax>[&]?ajax_component=(\d+))/);
					if ( ajaxMatch && ajaxMatch.groups && ajaxMatch.groups.ajax )
					{
						searchString = searchString.replace( ajaxMatch.groups.ajax, '' );
					}
					
					if ( searchString === '?' )
					{
						newHistoryItem = href + `${searchString}page=${nextPage}`;
					}
					else
					{
						newHistoryItem = href + `${searchString}&page=${nextPage}`;
					}
					
					href = `${newHistoryItem}&ajax_component=${componentId}`;
				}
				else
				{
					newHistoryItem = href + `?page=${nextPage}`
					href = `${newHistoryItem}&ajax_component=${componentId}`;
				}

				fetch( href, {
					method: 'GET',
					credentials: 'same-origin',
					headers: {
						'X-Requested-With': 'XMLHttpRequest',
					}
				})	
				.then(( response ) => response.json())
				.then(( data ) => {

					cardsList.insertAdjacentHTML( 'beforeend', data.components[componentId].rendered );
					window.history.pushState( {}, document.querySelector( 'head title' ).innerHTML, newHistoryItem );
					evt.target.setAttribute( 'data-next-page', ++nextPage );

					cardsList.querySelectorAll( 'li' ).forEach( ( elem ) => {
						elem.addEventListener( 'click', () => {
							document.cookie = `scroll=${window.scrollY}`;
						} )
					});
		
					if ( data.components[componentId].next_page === 0 ) 
					{
						button.style.display = 'none';
					} else
					{
						button.disabled = false;
					}
				})
				.catch(( err ) => {
					button.disabled = false;
					button.classList.add( 'show-error' );
					button.textContent = 'Произошла ошибка. Попробуйте позже.';
					console.error( err );
					setTimeout( () => {
						button.classList.remove( 'show-error' )
						button.textContent = 'Загрузить еще';
					}, 5000 );
				});
			});
		})
	}
}
